// extracted by mini-css-extract-plugin
export default {"loaderContainer":"LoadingWithSpinner_loaderContainer__tGPPn"};